<div>
    <span>{{ 'AdministrationPortal.InspectionCompanies.ForceTanUsage.Label' | translate }}:</span>&nbsp;
    <span class="font-bold">{{ forceTanLabel | translate}}</span>
</div>